import type { ComponentType, ReactNode } from "react";

export type FeatureItem = {
	icon?: ComponentType<{ className?: string }>;
	title: string;
	description: ReactNode;
};

export function FeatureGrid({
	features,
	columns = 3,
}: {
	features: FeatureItem[];
	columns?: 2 | 3;
}) {
	const colsClass =
		columns === 2 ? "sm:grid-cols-2" : "sm:grid-cols-2 lg:grid-cols-3";

	return (
		<div className={`grid gap-px bg-border ${colsClass}`}>
			{features.map((feature) => (
				<div
					key={feature.title}
					className="space-y-3 rounded-md bg-white dark:bg-black p-6"
				>
					{feature.icon && (
						<div className="flex size-10 items-center justify-center rounded-md border border-border bg-background">
							<feature.icon className="size-5 text-foreground" />
						</div>
					)}
					<h3 className="text-base font-medium text-foreground">
						{feature.title}
					</h3>
					<p className="text-sm leading-relaxed text-muted-foreground">
						{feature.description}
					</p>
				</div>
			))}
		</div>
	);
}
